import { ShieldAlert } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function AccessDeniedPage() {
  return (
    <Card>
      <CardHeader className="space-y-2 text-center">
        <ShieldAlert className="mx-auto h-12 w-12 text-destructive" />
        <CardTitle className="text-2xl">Access denied</CardTitle>
        <CardDescription>
          Your IP address is not on the digipop admin allowlist.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-muted-foreground">
        <p>
          The admin console is restricted to office and approved home IP addresses. Contact your
          DevOps lead to add a new IP — provide the address shown on{' '}
          <a
            href="https://ifconfig.me"
            target="_blank"
            rel="noreferrer"
            className="font-medium text-foreground underline underline-offset-4"
          >
            ifconfig.me
          </a>
          .
        </p>
        <p className="text-xs">
          Caddy serves this page after a 403 IP_NOT_ALLOWED response.
        </p>
      </CardContent>
    </Card>
  );
}
